import authClient from "../../app/auth/Auth";
import { handleRoute } from "../https";
import { MonetaryAmount } from "../../app/domain/monetary-amount";

// async for consistency
export function findCompanyId() {
  return authClient.getCompanyId();
}

export async function findCompanyDetail() {
  try {
    const res = await handleRoute({
      method: "get",
      path: `/v1/companies/${authClient.getCompanyId()}`,
    });
    return res;
  } catch (error) {
    if (error.code !== "ECONNABORTED") {
      return authClient.logOut();
    }
    return { data: {} };
  }
}

export async function checkPredictiveBalanceCompany() {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${authClient.getCompanyId()}/check-predictive-balance`,
  });
  return res;
}

export async function withdrawFundsCompany({ destinationAccount }) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${authClient.getCompanyId()}/withdraw-funds`,
    payload: { destinationAccount },
  });
  return res;
}

export async function fundCards({ employees, modelId }) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${authClient.getCompanyId()}/fund-cards`,
    payload: { employees, modelId },
  });
  return res;
}

export async function setBalanceAlert({ companyId, cents }) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}`,
    payload: {
      alertThresholdCents: cents,
    },
  });
  return res;
}

export async function accountFunding({ amountToFund }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${authClient.getCompanyId()}/company-funds-payment-gateway?amountToFundInCents=${amountToFund}`,
  });
  return res;
}

export async function chartTransactions() {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${authClient.getCompanyId()}/chart-transactions`,
  });
  return res;
}

export async function findCompanyConfigSettings() {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${authClient.getCompanyId()}/config-settings`,
  });
  return res;
}

export async function findHrAdmin() {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${authClient.getCompanyId()}/hrEmails`,
  });
  return res;
}

export async function createHrAdmin(email, password) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${authClient.getCompanyId()}/create-hr-admin`,
    payload: {
      email,
      password,
      companyId: authClient.getCompanyId(),
      lang: "es",
      corporationId: authClient.getCorporationId(),
    },
  });
  return res;
}

export async function deleteHrAdmin(email) {
  const res = await handleRoute({
    method: "delete",
    path: `/v1/companies/${authClient.getCompanyId()}/hrEmail/${email}`,
  });
  return res;
}

export async function updateCompanyConfigSettings({ configSettings }) {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${authClient.getCompanyId()}/config-settings`,
    payload: { configSettings },
  });
  return res;
}

export async function findTransactionsByCategory({ categories }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${authClient.getCompanyId()}/transactions?categories=${categories}`,
  });
  return res;
}

export async function findCompanySSOInformation({ slug }) {
  const res = await handleRoute({
    method: "get",
    path: `/public/v1/companies/${slug}/sso`,
  });
  return res;
}

export async function updateAlertThreshold({ companyId, amount, emails }) {
  try {
    const res = await handleRoute({
      method: "put",
      path: `/v2/companies/${companyId}/alert-threshold`,
      payload: {
        alertThresholdAmount: amount,
        alertThresholdEmails: emails,
      },
    });
    return res;
  } catch (error) {
    return error;
  }
}

export async function findCompanies(corporationId) {
  try {
    const res = await handleRoute({
      method: "get",
      path: `/companies/v1/corporations/${corporationId}/companies`,
    });
    return res;
  } catch (error) {
    return authClient.checkSession();
  }
}

export async function findCompanyLimit({ companyId, type, category, period }) {
  try {
    const res = await handleRoute({
      method: "get",
      path: `/v1/companies/${companyId}/limits/${type}/category/${category}/period/${period}`,
    });
    return MonetaryAmount.ofCurrency(res.data.content);
  } catch (error) {
    return authClient.checkSession();
  }
}
